$(function() {
  $('.compact-nav-toggle').on('click', function(e) {
    e.preventDefault();
    $('body').toggleClass('compact-nav-open');
    return false;
  });
  return $(window).scroll(function() {
    if ($('body').hasClass('compact-nav-open')) {
      return $('body').removeClass('compact-nav-open');
    }
  });
});

// ---
// generated by coffee-script 1.9.2